import FIltroDatas from './FIltroDatas.js'

const Filtros = (props) => {
  return(
    <div className='flex items-center justify-center gap-1 w-10/12 max-w-[500px] text-black'>
      <FIltroDatas datas={props.datas} selectData={props.selectData} setSelectData={props.setSelectData} />

      <div className='flex-col w-2/4'>
        <select value={props.gratis} className={`w-full ${props.gratis !== 'Pago' ? 'h-[60px]' : 'h-auto'}  text-center text-xl font-semibold`}onChange={(evento) => {
          props.setGratis(evento.target.value)
        }}>
          <option value=''>{props.gratis == 'Pago' || props.gratis == 'Gratis' ? 'Remover' : 'Valor'}</option>
          <option value='Gratis'>Gratis</option>
          <option value='Pago'>Pago</option>
        </select>
        {props.gratis == 'Pago' ? 
          <div className='flex justify-around text-xl gap-1'>
            <label className='text-purple-50 whitespace-nowrap'>Até R$</label>
            <input type='number' className='text-xl border w-2/4 md:w-6/12 h-1/3 rounded-md px-2 py-1' onChange={(evento) => props.setSelectValor(parseInt(evento.target.value))} />
          </div>
        : props.gratis == 'Gratis' ? props.setSelectValor(1) : props.setSelectValor(0)}
      </div>
    </div>
  )
}

export default Filtros